import {Tooltip} from "@mantine/core";
import {DibJsonNode} from "../../types";
import MessageCircle from "../../../../assets/message-circle.svg?react";
import classes from "./xFootnote.module.css";

type Props = {
    node: DibJsonNode;
};

export const XFootnote = ({node}: Props) => {
    const attrs = node.element?.attributes;
    const dataTitle = attrs?.["data-title"] ?? "";
    const id = attrs?.id;

    return (
        <Tooltip label={dataTitle} position="top" withArrow>
            <span id={id} className={classes.xFootnote}>
                <MessageCircle className={classes.icon} />
            </span>
        </Tooltip>
    );
};
